import { Provider } from '@angular/core';

import { NetworkUseCasesImpl } from '@app/domain/use-cases/network/network.use-cases';
import { NETWORK_USE_CASES } from '@app/domain/use-cases/network/network.use-cases.contract';

export const networkUseCasesProvider: Provider = {
  provide: NETWORK_USE_CASES,
  useClass: NetworkUseCasesImpl
};
